module.exports = __webpack_public_path__ + "img/icon_user.59d7aa5c.png";